
<template>
    <van-popup v-model="dataTipShow" round position="bottom" :style="{ height: '40%' }" closeable>
         <div class="container">
          <div class="title-container">
            <div class="title"> {{ $t('选择验证码接收方式') }} </div>
          </div>
         <div v-for="(item, index) in typeList" :class="['item-container',type === item ? 'item-container-select-color' :''] " :key="index" @click="clickItem(item)">
            <div :class="type === item ? 'item-text-selected' : 'item-text'" > {{ verifyText(item) }} </div>
            <img v-if="type === item" class="check-img" src="@/icons/list_check.png" />
         </div>
         </div>
     </van-popup>
   </template>
<script>

import { VerifyType } from '@/config/entrance.js'

export default {
  name: 'VerifyTypePopupView',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: VerifyType.SMS
    }
  },
  data() {
    return {
      typeList: [VerifyType.SMS, VerifyType.EMAIL],
      dataTipShow: this.show
    }
  },
  watch: {
    show: function(newValue, oldValue) {
      this.dataTipShow = newValue
    },
    dataTipShow: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {

    clickItem(item){
      this.$emit('onTypeClick', item)
      this.dataTipShow = false
    },

    verifyText(type) {
      switch (type) {
        case VerifyType.SMS:
          return this.$t('手机号码')
        case VerifyType.EMAIL:
          return this.$t('邮箱地址')
        default:
          return ''
      }
    }
  }
}
</script>
   <style lang="scss" scoped>
   .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background-color: white;
        .title-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            height: 55px;
            .title {
              padding: 0px 28px;
            font-size: 16px;
            font-weight: 500;
            color: #2C2C2C;
            text-align: center;
          }
        }

        .item-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 0px 28px;
            height: 64px;
            .item-text {
                font-size: 14px;
                font-weight: 500;
                color: #2C2C2C;
            }
            .item-text-selected {
                font-size: 14px;
                font-weight: 500;
                color: #00BBBF;
            }
            .check-img {
                width: 24px;
                height: 24px;
            }
        }
        .item-container-select-color {
            background-color: rgba(0, 187, 191, 0.1);
        }
   }
   </style>
